// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 951 ? "48dfa7f8" : chunkId) + "." + {"496":"a5c42d14b8ff0abd","951":"233b83ee71b8ebcb"}[chunkId] + ".js";
};